export const getCompareApiNames = ({
  compare
}) => {
  if (!compare || !Object.keys(compare).length) return [];
  return compare.apiNames;
};
export const getCompareFeatures = ({
  compare
}) => {
  if (!compare || !Object.keys(compare).length) return [];
  return compare.features;
};
export const isApiNameInCompare = ({
  compare
}, {
  apiName
}) => {
  if (!compare || !Object.keys(compare).length) return false;
  return compare.apiNames.includes(apiName);
};
export const isCompareAtLimit = ({
  compare
}) => {
  return getCompareApiNames({
    compare
  }).length === 4;
};